<template>
  <article>
    <header class="title-bar zz-title-bar">
      <h2>选择车型</h2>
    </header>
    <div v-for="(series, index) in seriesList" :key=index>
      <span class="title_lab"><label>{{series[0].manufacturer}}</label></span>
      <ul class="car-list">
        <li v-for="(item, index) in series" :key="index" @click.stop="selModel(item.id)"><a href="javascript:void(0);">{{item.name}}</a></li>
      </ul>
    </div>
  </article>
</template>
<script>
export default {
  data () {
    return {
      brandId: '',
      seriesList: []
    }
  },
  created () {
    this.brandId = this.$route.params.brandId
    if (this.brandId) {
      this.$rest.saleManage.getCarBrandList(null, this.brandId + '/series').then((res) => {
        if (res.code === 0) {
          let dataList = {}
          let series = res.series
          series.forEach((v) => {
            if (!dataList[v.manufacturer]) {
              dataList[v.manufacturer] = []
              dataList[v.manufacturer].push({ name: v.name, id: v.id, manufacturer: v.manufacturer })
            } else {
              dataList[v.manufacturer].push({ name: v.name, id: v.id, manufacturer: v.manufacturer })
            }
          })
          this.seriesList = dataList
        } else {
          this.showToast(res.message)
        }
      })
    } else {
      this.showToast('brandId不存在')
    }
  },
  methods: {
    selModel (seriesId) {
      this.$router.push({
        path: '/salemanage/car/models/' + seriesId
      })
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less">
</style>
